export const deviceButtonTitle = {
  TO_BASKET: 'В корзину',
  IN_BASKET: 'В корзине',
  PRE_ORDER: 'Предзаказ',
  PRE_ORDER_EXTENDED: 'Оформить предзаказ',
  RESEND: 'Повторить заявку',
  OUT_OF_STOCK_PREORDER: 'Оставить заявку',
  OUT_OF_STOCK: 'Нет в наличии',
};

export const DEVICE_LIST_ROW_PADDING = {
  MOBILE: 40,
  DESKTOP: 64,
};

export const deviceVariant = {
  SECONDARY: 'secondary',
  TERTIARY: 'tertiary',
  MAIN: 'main',
};
